import { z } from 'zod';

/**
 * A file name is a label and nothing more: stored for a person to recognise,
 * never used in a key, a path or a content type.
 */
export const fileNameSchema = z
  .string()
  .trim()
  .min(1)
  .max(200)
  .transform((name) => name.replace(/[\\/\p{Cc}]/gu, '_'));

/**
 * What a presigned upload hands back. The token is signed by the server and
 * named again on the call that commits the file, so the browser can choose
 * neither the object key nor the size the URL was signed for.
 */
export const presignedUploadSchema = z.object({
  uploadToken: z.string(),
  uploadUrl: z.string(),
  expiresAt: z.string(),
});

export type PresignedUpload = z.infer<typeof presignedUploadSchema>;

export const uploadTokenSchema = z.string().min(1).max(2000);
